import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

import { Tooltip } from '../tooltip/Tooltip'

import classes from './Footer.module.scss'

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <ul className={classes.footer__icons}>
        <li>
          <Tooltip content="Email me!" direction="top">
            <a
              href="mailto:stina.nerin@gmail.com"
              aria-label="Contact Stina via email."
            >
              <FontAwesomeIcon icon={faEnvelope} aria-hidden="true" />
            </a>
          </Tooltip>
        </li>
        <li>
          <Tooltip content="Github" direction="bottom">
            <a
              href="https://github.com/stormstina"
              aria-label="View Stina's github profile"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* rel="noopener noreferrer" :
              prevents tabnabbing attacks and information leakage, 
              when opening links in a new tab or window */}
              <FontAwesomeIcon icon={faGithub} aria-hidden="true" />
            </a>
          </Tooltip>
        </li>
        <li>
          <Tooltip content="Linkedin" direction="top">
            <a
              href="https://www.linkedin.com/in/stina-nerin/"
              target="_blank"
              aria-label="Contact Stina via linkedin"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedin} aria-hidden="true" />
            </a>
          </Tooltip>
        </li>
      </ul>
    </footer>
  )
}

export default Footer
